// extracted by mini-css-extract-plugin
export default {"input":"Checkbox_input__4H3Or","label":"Checkbox_label__LN1hG","icon":"Checkbox_icon__Qa790"};